import store from '../store'
const getMeetingsList= async function(payload) {
    
    return  await axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/virtual_machine/meetings",
        method: "GET",
        headers: {
            Authorization: store.get("login/token"),
        },
        params: payload,
    })
  }
const getAttendees= async function(payload) {
    
    return  await axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/virtual_machine/attendees",
        method: "GET",
        headers: {
            Authorization: store.get("login/token"),
        },
        params: payload,
    })
  }
const getServersList= async function(payload) {
    
    return  await axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/virtual_machine",
        method: "GET",
        headers: {
            Authorization: store.get("login/token"),
        },
        params: payload,
    })
  }  
  export {
    getMeetingsList,
    getAttendees,
    getServersList
  }